module.exports = __webpack_public_path__ + "static/sw-648c1481b5c95830a2d1d3277b9955c9.png";